import { Field } from "formik";
import { CMDropdown, CMDropdownContainer } from "./dropdownOrder.styles";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
} from "@mui/material";
import { ReactComponent as ArrowIcon } from "../../icons/arrow-down-short.svg";

export const FormField = ({ field, ...props }) => {
  return <CMDropdown {...field} {...props} IconComponent={ArrowIcon} />;
};

const DropdownOrder = ({
  options,
  name,
  defaultValue,
  isFormikControl = true,
  className,
  ...props
}) => {
  return (
    <>
      <CMDropdownContainer className={`dropdown-container DropdownOrder-preview ${className}`}>
        <FormControl>
          {isFormikControl ? (
            <Field as="select" name={name} component={FormField} {...props}>
              <MenuItem value={"selected"}>Select an option</MenuItem>
              {props.multiple === true
                ? options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                      <Checkbox
                        checked={
                          props.value.findIndex((e) => e === option.value) !==
                          -1
                        }
                      />
                      {option.text}
                    </MenuItem>
                  ))
                : options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
            </Field>
          ) : (
            <FormField {...props} className={`${className}`}>
              <MenuItem value="" disabled>
                Select an option
              </MenuItem>
              {props.multiple === true
                ? options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                      <Checkbox
                        checked={
                          props.value.findIndex((e) => e === option.value) !==
                          -1
                        }
                      />
                      {option.text}
                    </MenuItem>
                  ))
                : options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
            </FormField>
          )}
        </FormControl>
      </CMDropdownContainer>
    </>
  );
};

export default DropdownOrder;
